import { CONDITION_DESCRIPTION_MAX_LENGTH } from "../data/useTemplateConditionDescription";

export type AppendResult = { text: string; error?: undefined } | { text?: undefined; error: string };

/**
 * Adds the AI condition description to the end of what is already in the condition box, so a
 * template's text (or the lister's own) is kept rather than replaced. Refuses rather than cuts when
 * the result would be over eBay's limit - a half sentence of AI text is worse than none.
 */
export function appendToConditionDescription(
  current: string | null | undefined,
  addition: string,
  maxLength: number = CONDITION_DESCRIPTION_MAX_LENGTH,
): AppendResult {
  const existing = (current ?? "").trimEnd();
  const added = (addition ?? "").trim();

  if (!added) return { text: current ?? "" };

  if (existing.includes(added)) return { error: "The AI description is already in the condition description" };

  const text = existing ? `${existing} ${added}` : added;

  if (text.length > maxLength) {
    return {
      error: `The AI description doesn't fit - adding it would make the condition description ${text.length.toLocaleString()} characters, and eBay allows ${maxLength.toLocaleString()}`,
    };
  }

  return { text };
}
